import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    this.printOnVisit()
  }
  
  reload(event) {
    event.preventDefault()
    window.location.reload()
  }
  
  print(event) {
    event.preventDefault()
    Turbolinks.visit(window.location + '&print=true')
  }
  
  printOnVisit() {
    if (window.location.href.match('&print=true')) {
      window.print()
    }
  }
}